module.exports = __webpack_public_path__ + "img/set-up-miscellaneous.e75e1533.svg";